import { Injectable } from '@angular/core';
import {
    UrlTree,
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
} from '@angular/router';
import { Apollo, gql } from 'apollo-angular';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/notification/notification.service';

const query = gql`
    query Query {
        olsCheckoutState @client {
            recipientEmail
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class CanActivatePurchaseAndSummaryGuard implements CanActivate {
    constructor(
        private router: Router,
        private apollo: Apollo,
        private notificationService: NotificationService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.apollo.query({ query }).pipe(
            map((result: any) => {
                if (!result.data.olsCheckoutState?.recipientEmail?.length) {
                    return this.router.parseUrl('/gift');
                } else {
                    return true;
                }
            }),
            catchError((err) => {
                this.notificationService.showFailure(err);
                return of(false);
            })
        );
    }
}
